// Anthropic 側で実行されるサーバー側ツールの宣言。
// ローカルハンドラを持たないため ToolRegistry には登録せず、
// App.jsx の callModel クロージャで tools 配列へ連結して送る（別途課金）。
//
// 型は動的フィルタリング対応の GA 版（web_search_20260209）。
// 対応モデル: Opus 4.8/4.7/4.6, Sonnet 4.6（既定の claude-sonnet-4-6 を含む）。

export const SERVER_TOOL_DEFS = {
  webSearch: { type: "web_search_20260209", name: "web_search" },
};

/**
 * トグル状態から、有効なサーバー側ツール定義の配列を組み立てる。
 * 同じトグルなら同じ配列になり、プロンプトキャッシュのプレフィックス安定性を保つ。
 */
export function buildServerTools({ webSearch } = {}) {
  const tools = [];
  if (webSearch) tools.push(SERVER_TOOL_DEFS.webSearch);
  return tools;
}
